import { styled } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';

import styles from './zoomControls.module.scss';

interface ZoomControlProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  isZoomOutDisabled: boolean;
  isZoomInDisabled: boolean;
}

export const ZoomControls: React.FC<ZoomControlProps> = ({
  onZoomIn,
  onZoomOut,
  isZoomOutDisabled,
  isZoomInDisabled,
}) => {
  const ZoomBase = styled(Button)({
    width: '56px',
    height: '56px',
  });
  const ZoomOut = styled(ZoomBase)({
    borderRadius: '0 0 10px 10px',
  });
  const ZoomIn = styled(ZoomBase)({
    borderRadius: '10px 10px 0 0',
  });
  return (
    <div className={styles.zoomControls}>
      <div className={styles.zoomInWrapper}>
        <ZoomIn
          onClick={onZoomIn}
          className={`${styles.zoomIn} ${isZoomInDisabled && styles.disabled}`}
          disabled={isZoomInDisabled}
        >
          <div className={styles.label}>+</div>
        </ZoomIn>
      </div>
      <div className={styles.zoomOutWrapper}>
        <ZoomOut
          onClick={onZoomOut}
          className={` ${styles.zoomOut} ${
            isZoomOutDisabled && styles.disabled
          }`}
          disabled={isZoomOutDisabled}
        >
          <div className={styles.label}>-</div>
        </ZoomOut>
      </div>
    </div>
  );
};
